(()=>{
  const api='/apps/gascanco-garage/community';
  let request;
  const text=(tag,cls,value)=>{const el=document.createElement(tag);el.className=cls;el.textContent=value||'';return el;};
  async function mount(config){
    const root=document.getElementById(config.dataset.garageBannerConfig);
    if(!root || root.dataset.liveBanner)return;
    root.dataset.liveBanner='true';
    const s=JSON.parse(config.textContent), empty=text('div','gg-feature__empty','');
    const fallback=document.createElement('div');
    fallback.append(text('p','gg-feature__eyebrow',s.eyebrow),text('p','',s.empty_text));
    empty.append(fallback);root.replaceChildren(empty);
    try{
      request ||= fetch(api+'/api/public-banner',{credentials:'omit',cache:'no-store'}).then(r=>{if(!r.ok)throw Error();return r.json();});
      const {vehicles}=await request;
      if(!vehicles?.length)return;
      const v=vehicles[Math.floor(Math.random()*vehicles.length)], title=[v.year,v.make,v.model].filter(Boolean).join(' ');
      const route=(base,vehicle)=>{
        let url;try{url=new URL(base,location.origin);}catch{}
        if(!url || url.origin!==location.origin || !['/pages/garage','/pages/garage-feed'].includes(url.pathname))url=new URL('/pages/garage',location.origin);
        for(const key of ['garage','vehicle','event','post','garage_view'])url.searchParams.delete(key);
        url.searchParams.set(vehicle?'vehicle':'garage',vehicle?v.id:v.owner.id);
        return url.pathname+url.search;
      };
      const vehicleUrl=route(s.vehicle_page,true), ownerUrl=route(s.owner_page,false);
      const vehicle=text('div','gg-feature__vehicle',''), image=document.createElement('img');
      image.className='gg-feature__image';image.alt=title;image.src=v.primaryImage.startsWith('/media/')?api+v.primaryImage:v.primaryImage;
      image.decoding='async';
      // Preserve a clean fallback when a removed photo is no longer available.
      await new Promise((resolve,reject)=>{image.onload=resolve;image.onerror=reject;});
      const content=text('div','gg-feature__content',''), inner=text('div','gg-feature__inner','');
      const firstName=v.owner.firstName||'Member';
      inner.append(text('p','gg-feature__eyebrow',s.eyebrow),text('h2','gg-feature__heading gg-feature__vehicle-title',`${firstName}'s ${title}`));
      if(s.show_color && v.color)inner.append(text('p','gg-feature__detail',[s.color_label,v.color].filter(Boolean).join(' ')));
      if(s.show_mods && v.mods)inner.append(text('p','gg-feature__mods',String(v.mods).split(/\s+/).slice(0,s.mods_words||10).join(' ')));
      if(s.show_state && v.state)inner.append(text('p','gg-feature__detail',v.state));
      const buttons=text('div','gg-feature__buttons','');
      const ownerLabel=(s.owner_button_label||"[First Name]'s Garage").replaceAll('[First Name]',firstName);
      for(const [show,label,href,secondary] of [[s.show_vehicle_link,s.vehicle_button_label||'Vehicle Details',vehicleUrl,false],[s.show_owner_link,ownerLabel,ownerUrl,true]]){
        if(show){const link=text('a','gg-feature__button'+(secondary?' gg-feature__button--secondary':''),label);link.href=href;buttons.append(link);}
      }
      const photo=text('div','gg-feature__photo','');photo.append(image);
      inner.append(buttons);content.append(inner);vehicle.append(photo,content);root.replaceChildren(vehicle);
    }catch{/* Keep the configured fallback visible on network or photo failures. */}
  }
  const all=()=>document.querySelectorAll('[data-garage-banner-config]').forEach(mount);
  all();document.addEventListener('shopify:section:load',()=>{request=undefined;all();});
})();
